import { render, staticRenderFns } from "./ListData.vue?vue&type=template&id=27d679e5&scoped=true&"
import script from "./ListData.vue?vue&type=script&lang=js&"
export * from "./ListData.vue?vue&type=script&lang=js&"
import style0 from "./ListData.vue?vue&type=style&index=0&id=27d679e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d679e5",
  null
  
)

export default component.exports